import { Vue, Component } from 'vue-property-decorator'
import LocationSvg from '~/assets/svg/popup-location.svg?inline'
import s from '~/utils/s'

@Component
export default class OrderDetailHeader extends Vue {
  get orderRegionName () {
    const targetRegion = s(this.$store).regions.flatRegions.find(e => e.id === s(this.$store).orderDetailPage.regionId)
    if (targetRegion) {
      return targetRegion.regionName
    }
  }

  render () {
    return (
      <div class="order-detail-header__item">
        <h1 class="order-detail-header__number">
          Заказ №{s(this.$store).orderDetailPage.number}
        </h1>
        <div class="order-detail-header__region-item">
          <div class="order-detail-header__icon">
            <LocationSvg />
          </div>
          <h4 class="order-detail-header__region-text">
            {this.orderRegionName}
          </h4>
        </div>
      </div>
    )
  }
}
